export default __webpack_public_path__ + "static/media/creation.0abd5f71.png";